import {
  LIST_PROMPT_BLOCK_VERSIONS_ROUTE,
  CREATE_PROMPT_BLOCK_VERSION_ROUTE,
  GET_PROMPT_BLOCK_VERSION_ROUTE,
  ACTIVATE_PROMPT_BLOCK_VERSION_ROUTE,
  RESTORE_PROMPT_BLOCK_VERSION_ROUTE,
  DELETE_PROMPT_BLOCK_VERSION_ROUTE,
  COMPARE_PROMPT_BLOCK_VERSIONS_ROUTE,
} from '../../handlers/prompt-block-versions';
import {
  LIST_STORED_PROMPT_BLOCKS_ROUTE,
  GET_STORED_PROMPT_BLOCK_ROUTE,
  CREATE_STORED_PROMPT_BLOCK_ROUTE,
  UPDATE_STORED_PROMPT_BLOCK_ROUTE,
  DELETE_STORED_PROMPT_BLOCK_ROUTE,
} from '../../handlers/stored-prompt-blocks';

export const STORED_PROMPT_BLOCKS_ROUTES = [
  // Stored Prompt Blocks CRUD Routes
  LIST_STORED_PROMPT_BLOCKS_ROUTE,
  GET_STORED_PROMPT_BLOCK_ROUTE,
  CREATE_STORED_PROMPT_BLOCK_ROUTE,
  UPDATE_STORED_PROMPT_BLOCK_ROUTE,
  DELETE_STORED_PROMPT_BLOCK_ROUTE,

  // Prompt Block Versions Routes
  // IMPORTANT: Routes with literal paths (e.g., /compare) must come BEFORE
  // routes with path parameters (e.g., /:versionId) to ensure correct matching.
  LIST_PROMPT_BLOCK_VERSIONS_ROUTE,
  CREATE_PROMPT_BLOCK_VERSION_ROUTE,
  COMPARE_PROMPT_BLOCK_VERSIONS_ROUTE,
  GET_PROMPT_BLOCK_VERSION_ROUTE,
  ACTIVATE_PROMPT_BLOCK_VERSION_ROUTE,
  RESTORE_PROMPT_BLOCK_VERSION_ROUTE,
  DELETE_PROMPT_BLOCK_VERSION_ROUTE,
] as const;
